import http from 'axios'
import store from '@/store'
import getErrorStatusCode from '@/utils/error_status_code'
import { getSignInURL } from '@/utils/tool'

const _lastUpdated = new WeakMap()

class Model {

  constructor() {
    _lastUpdated.set(this, Date.now())
  }

  // 取得最後更新時間
  get lastUpdated() {
    return _lastUpdated.get(this)
  }

  // 是否已經過期？
  get isExpired() {
    return Date.now() - this.lastUpdated > 1000 * 60 * 3
  }

  static get baseURL() {
    return process.env.ENDPOINT
  }

  /**
   * api 介面提供需要認證的 HTTP request，它會在 HTTP headers 塞入 token 或是相關需要驗證的資料。
   *
   * @return {Object} The axios instance object
   *
   * @example
   *
   * ``` js
   * this.api.get(`projects`)
   * this.api.get(`private/resources`)
   * ```
   *
   */
  static get api() {
    if (!this._api) {
      this._api = http.create()
      this._api.defaults.baseURL = this.baseURL
      this._api.defaults.headers.common['Accept'] = 'application/json'
      this._api.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8'
      this._api.interceptors.response.use(res => res, this.onAPIError)
    }
    this._api.defaults.headers.common['Authorization'] = store.state.account.token
    return this._api
  }

  static get http() {
    if (!this._http) {
      this._http = http.create()
      this._http.defaults.baseURL = this.baseURL
      this._http.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8'
      this._http.defaults.headers.common['Accept'] = 'application/json'
      this._http.interceptors.response.use(res => res, this.onHTTPError)
    }
    return this._http
  }

  /**
   * inject response status code to error object on error happened
   * @private
   */
  static onAPIError(err) {
    const code = getErrorStatusCode(err)
    if (code) {
      err.code = code
    }

    if (err.code === 401) {
      window.open(getSignInURL(), 'signin', 'width=640,height=700')
    }

    return Promise.reject(err)
  }

  /**
   * @private
   */
  static onHTTPError(err) {
    const code = getErrorStatusCode(err)
    if (code) {
      err.code = code
    }

    return Promise.reject(err)
  }
}

export default Model



// WEBPACK FOOTER //
// ./src/models/model.js